<script lang="ts" setup>
import { useFetch } from '@/home/hooks/fetch';
import { useAsyncData } from '@/home/hooks/async-data';

const { $fetch } = useFetch();

const { data: imgList } = useAsyncData(
  'home:operation',
  () => $fetch('/operator/getOperatorList', { method: 'post', data: { operateType: 3, pageSize: 3 } }),
);
</script>

<template>
  <ul>
    <li v-for="item in imgList" :key="item.jumpUrl" class="mt-40 rounded-10">
      <a :href="item.jumpUrl" target="_blank">
        <img :src="item.picUrl" class="h-180 w-full rounded-10 object-cover" :alt="item.operateName" :title="item.operateName">
      </a>
    </li>
  </ul>
</template>

<style lang="scss" scoped>
</style>
